type PageInitializer = (root?: ParentNode) => void;

const pageInitializers = new Map<string, PageInitializer>();

export function registerPageInit(namespace: string, init: PageInitializer): void {
  pageInitializers.set(namespace, init);
}

export function runPageInit(namespace: string | undefined, root?: ParentNode): void {
  if (!namespace) return;
  const init = pageInitializers.get(namespace);
  if (init) init(root);
}

export function getNamespaceFromDom(barbaContainer?: Element | null): string | undefined {
  const root =
    barbaContainer ??
    document.querySelector<HTMLElement>('[data-barba="container"]');
  if (!root) return undefined;
  const el = root as HTMLElement;
  return (
    el.dataset.barbaNamespace ??
    el.querySelector<HTMLElement>('[data-barba-namespace]')?.dataset.barbaNamespace
  );
}
